import { isEqual } from "lodash-es";

export default function sameOrNull(array) {
  if (!array?.length) return null;
  const value = array[0];
  if (array.every((v) => isEqual(v, value))) return value;
  return null;
}
